export { default as SparklesSolidIcon } from './SparklesSolidIcon';
